import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CheckoutProgressMobileTopComponent } from '@spartacus/checkout/base/components';
import { ICON_TYPE } from '../../../../../../../custom/icons/icon.model';

@Component({
  selector: 'cx-checkout-progress-mobile-top',
  templateUrl: './checkout-progress-mobile-top.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})

export class CustomCheckoutProgressMobileTopComponent extends CheckoutProgressMobileTopComponent {
  iconType = ICON_TYPE;
}
